import { t } from "i18next";
import type { FC } from "react";
import { useEffect, useState } from "react";
import { useRootStore } from "../../../../../../../../../../stores/hooks";
import { useRepeatedSchedule } from "../../repeated-schedule.hook";
import * as S from "./style";
import { MonthDayPicker } from "@smartsuite/react-ui/lib";

export const MonthDay: FC = () => {
  const [value, setValue] = useState<number[]>([]);

  const { scheduleStore } = useRootStore();
  const { getMonthDays, setMonthDays } = useRepeatedSchedule();

  useEffect(() => {
    setValue(getMonthDays());
  }, [scheduleStore.schedule]);

  return (
    <>
      <S.Pipe />
      <S.Wrapper>
        <MonthDayPicker
          className="monthday-text"
          lastMonthDayButtonLabel={t("scheduled-trigger.last-day-of-month")}
          selected={value}
          onChange={(days) => setMonthDays(days)}
        />
      </S.Wrapper>
      <S.Pipe />
    </>
  );
};
